import React, { CSSProperties, useEffect, useState } from 'react'
import classnames from 'classnames'
import { Icon } from 'meinian-package/src/component'
import globalData from 'meinian-package/src/common/globalData'
import styles from './index.module.less'

interface Props {
    className?: string;
    message: any,
    style?: CSSProperties,
    keyValue?:string,
    onClose?: ()=>void,
    onVisibleChange?:(num:any)=>void,
}

export default ({ message, className, style, onClose, keyValue, onVisibleChange }:Props) => {
  const [visible, setVisible] = useState(0)
  useEffect(() => {
    if (keyValue) {
      globalData.get(keyValue, setVisible, 1)
    }
  }, [])

  useEffect(() => {
    onVisibleChange?.(visible)
  }, [visible])

  const _onClose = () => {
    if (keyValue) {
      globalData.set(keyValue, 0)
      setVisible(0)
    }
    onClose?.()
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>
    {!!visible && <div className={classnames(styles['mn-alert'], className)} style={style}>
      <span className="content-left">
        <Icon type="m-xinxi_tianchong" className="alert-icon" />
        <div className="alert-message">{message}</div>
      </span>
      <div className="mn-alert-close" onClick={_onClose}>
        <Icon type="m-guanbi" />
      </div>
    </div>}
  </>
}
